import React, { useState } from 'react';
import { IcoChevron, IcoX, IcoMove } from './EditIcons';
import styles from './EditShared.module.css';

export function Label({ children, required }) {
  return (
    <div className={styles.labelContainer}>
      <span className={styles.labelText}>{children}</span>
      {required && <span className={styles.required}>*</span>}
    </div>
  );
}

export function InputBox({ value, onChange, placeholder, style, readOnly, disabled }) {
  return (
    <input
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      readOnly={readOnly}
      disabled={disabled}
      className={styles.input}
      style={style}
    />
  );
}

export function SelectBox({ value, onChange, options }) {
  return (
    <div className={styles.selectContainer}>
      <select
        value={value}
        onChange={onChange}
        className={styles.select}
      >
        {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      <div className={styles.chevron}>
        <IcoChevron />
      </div>
    </div>
  );
}

export function FieldRow({ children, style }) {
  return (
    <div className={styles.fieldRow} style={style}>
      {children}
    </div>
  );
}

export function Field({ label, required, hint, children, flex = 1 }) {
  return (
    <div className={styles.fieldContainer} style={{ flex }}>
      <Label required={required}>{label}</Label>
      {children}
      {hint && <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#A2A2A2', fontFamily: 'Pretendard, sans-serif', lineHeight: '1.4' }}>{hint}</p>}
    </div>
  );
}

export function PhotoUploaded({ src, onRemove, size = 226, fluid = false }) {
  const [hover, setHover] = useState(false);
  return (
    <div
      className={styles.photoContainer}
      style={{ ...(fluid ? { flex: 1 } : { width: size, flexShrink: 0 }) }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <img src={src} alt="" className={styles.photoImg} />
      {hover && (
        <div className={styles.overlay}>
          <button className={styles.actionBtn} style={{ background: '#fff' }}>
            <IcoMove />
          </button>
          <button onClick={onRemove} className={styles.actionBtn} style={{ background: '#121212' }}>
            <IcoX color="#fff" />
          </button>
        </div>
      )}
    </div>
  );
}

export function SkillTag({ label, onRemove }) {
  return (
    <div className={styles.tag}>
      <span className={styles.tagText}>{label}</span>
      <button onClick={onRemove} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex' }}>
        <IcoX />
      </button>
    </div>
  );
}

export function SkillOption({ label, selected, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`${styles.skillOption} ${selected ? styles.skillOptionSelected : ''}`}
    >
      {label}
    </button>
  );
}

export function SkillCategory({ category, selected, onToggle }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={styles.category}>
      <button
        onClick={() => setOpen(p => !p)}
        className={`${styles.skillCategoryHeader} ${open ? styles.skillCategoryHeaderOpen : ''}`}
      >
        <span className={styles.categoryLabel}>{category.label}</span>
        <IcoChevron up={open} />
      </button>
      {open && (
        <div className={styles.skillCategoryContent}>
          {category.groups.map((group, gi) => (
            <div key={gi} className={styles.skillGroup}>
              {group.name && <span className={styles.groupName}>{group.name}</span>}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {group.items.map(item => (
                  <SkillOption key={item} label={item} selected={selected.includes(item)} onClick={() => onToggle(item)} />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
